export default __webpack_public_path__ + "static/media/mus-nineball.1b8209dc.mp4";